import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_modal_header_notification = _resolveComponent("modal-header-notification")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_FocusLock = _resolveComponent("FocusLock")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visible) = $event)),
    width: "500"
  }, {
    activator: _withCtx(({}) => [
      _createVNode(_component_v_btn, {
        class: "px-3 mr-2",
        color: "primary",
        onClick: _ctx.open
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.dialogTitle), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
      }, [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_FocusLock, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "headline font-weight-bold mb-2" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.dialogTitle), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_modal_header_notification),
                _createVNode(_component_v_card_text, { class: "pb-0 pt-0" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      modelValue: _ctx.selectedTeilnehmer,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTeilnehmer) = $event)),
                      items: _ctx.teilnehmerZugriffCreateList,
                      label: _ctx.benutzerRolleLabel
                    }, null, 8, ["modelValue", "items", "label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, { class: "pb-0 pt-0" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createTextVNode(_toDisplayString(_ctx.dialogInfotext) + " ", 1),
                      _createElementVNode("a", {
                        href: _ctx.locale === 'fr' ? 'https://vetdata.ch/fr/pricing' : 'https://vetdata.ch/pricing/',
                        target: "_blank"
                      }, _toDisplayString(_ctx.locale === 'fr' ? 'https://vetdata.ch/fr/pricing' : 'https://vetdata.ch/pricing/'), 9, _hoisted_1)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, { class: "ml-4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      type: "submit",
                      variant: "flat",
                      class: "modalbutton mb-3"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('components.dialog.save')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      class: "modalbutton mb-3",
                      variant: "flat",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.visible = false))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('components.dialog.cancel')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ], 32)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}